import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/client/receive-list'

const URL = '/rest/customer/feedback/resourceCount/dayResourceCount'

export default {
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/client/receive-list.js